export interface CirculationModel {
    id: number,
    metricCode?: number | null,
    name: string    
}

export const circulationModelInitial: CirculationModel = {
    id: 0,
    metricCode: null,
    name: ''
};